var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0759 1.83301L4.75757 5.16051",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9241 1.83301L17.2424 5.16051",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 7.19564C1.83325 5.4998 2.74075 5.3623 3.86825 5.3623H18.1316C19.2591 5.3623 20.1666 5.4998 20.1666 7.19564C20.1666 9.16647 19.2591 9.02897 18.1316 9.02897H3.86825C2.74075 9.02897 1.83325 9.16647 1.83325 7.19564Z",
    stroke: "#1E1531",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94678 12.833V16.0872",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1633 12.833V16.0872",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20825 9.16699L4.50075 17.087C4.79408 18.8653 5.49992 20.167 8.12158 20.167H13.6491C16.4999 20.167 16.9216 18.9203 17.2516 17.197L18.7916 9.16699",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product-icon.b94f9ab7907ffa204f31555c95f22e3d.svg";
export { ForwardRef as ReactComponent };